import React, { useState } from "react";
import { deleteEstimate } from "../../api/estimates/EstimateAPI";
import Spinner from "../common/Spinner";
import { hasRoles } from "../../utils/roles";
import PropTypes from "prop-types";

DeleteEstimateButton.propTypes = {
  project: PropTypes.object,
  CPs: PropTypes.object,
  estimate_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  project_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  user: PropTypes.object,
  estimateName: PropTypes.string,
  CP: PropTypes.object,
};
export default function DeleteEstimateButton(props) {
  const { project } = props;
  const { CPs } = props;
  const { estimate_id, project_id } = props;
  const { user } = props;
  const { estimateName } = props;
  const [isDeleting, setIsDeleting] = useState(false);
  const { CP } = props;

  if (!hasRoles(user.roles, ["CostManager"])) {
    return null;
  }

  if (project.project_phase !== "COST_PLANNING") {
    return null;
  }

  if (isDeleting) {
    return <Spinner width={"50px"} marginLeft={"15px"} />;
  }

  return (
    <button
      className={
        CP.pcra_log.isPublished
          ? "estimate-delete-button disabled"
          : "estimate-delete-button"
      }
      id={"estimate-delete-button"}
      onClick={async () => {
        const confirm = window.confirm(
          `Confirm delete ${estimateName}? This cannot be undone.`
        );

        if (!confirm) {
          return;
        }

        setIsDeleting(true);
        await deleteEstimate(estimate_id, project_id, CP.cost_plan_id);
        let data = await CPs.get(project.id, project);

        // Set the new data with the getters and setters
        CPs.set(data);
        setIsDeleting(false);
      }}
      disabled={CP.pcra_log.isPublished}
    >
      <i className="far fa-trash-alt"></i>
    </button>
  );
}
